const libFableServiceProviderBase = require('fable-serviceproviderbase');

const defaultHeadlightGUIDMapOptions = (
	{
		// Nothing here yet.
		// Maybe overwrite rules?  Right now it's just obliterate.
		// When we add persistence that would be here as well.
	});

class HeadlightGUIDMap extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, defaultHeadlightGUIDMapOptions, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('fable') & { HeadlightRestClient: import('headlight-rest-client') }} */
		this.fable;
		this.serviceType = 'HeadlightGUIDMap';

		// For now, keep GUID mappings to IDs in memory forever.
		// At the moment, we don't have enough data throughput for that to be a problem really.
		// When it becomes so, we can shift the persistence to some kind of key-value store.
		// These are back and forth between the Headlight GUIDs and the Headlight IDs
		this._GUIDMap = {};
		this._IDMap = {};

		// Keep track of *external* GUIDS that map to Headlight GUIDs
		this._ExternalGUIDMap = {};
	}

	// Add an entity for the mapping
	addEntity(pEntity)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this._GUIDMap[pEntity] = {};
			this._IDMap[pEntity] = {};
			this._ExternalGUIDMap[pEntity] = {};
		}

		return true;
	}

	// Map a Headlight GUID to an ID
	mapGUIDToID(pEntity, pGUID, pID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		this._GUIDMap[pEntity][pGUID] = pID;
		this._IDMap[pEntity][pID] = pGUID;

		return true;
	}

	// Get an ID from a GUID
	getIDFromGUID(pEntity, pGUID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		return (this._GUIDMap[pEntity].hasOwnProperty(pGUID)) ? this._GUIDMap[pEntity][pGUID] : false;
	}

	/**
	 * @param {string} pEntity
	 * @param {string} pGUID
	 * @param {(pError: Error|null, pID?: number|false) => void} fCallback
	 * @param {import('headlight-rest-client')} [pClient] - the client instance to use; defaults to the default fable service
	 */
	getIDFromGUIDAsync(pEntity, pGUID, fCallback, pClient)
	{
		const tmpClient = pClient || this.fable.HeadlightRestClient;
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		// If it has already been loaded, return it.
		if (this._GUIDMap[pEntity].hasOwnProperty(pGUID))
		{
			fCallback(null, this._GUIDMap[pEntity][pGUID]);
		}
		else
		{
			// Try to load it from the server
			tmpClient.getEntityByGUID(pEntity, pGUID,
				(pError, pBody) =>
				{
					if (pError)
					{
						return fCallback(pError);
					}
					else
					{
						let tmpEntityIDName = `ID${pEntity}`;
						if (pBody && pBody.hasOwnProperty(tmpEntityIDName))
						{
							this.mapGUIDToID(pEntity, pGUID, pBody[tmpEntityIDName]);
							return fCallback(pError, pBody[tmpEntityIDName]);
						}
						else
						{
							return fCallback(pError, false)
						}
					}
				});
		}
	}

	// Get a GUID from an ID
	getGUIDFromID(pEntity, pID)
	{
		if (!this._IDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		return (this._IDMap[pEntity].hasOwnProperty(pID)) ? this._IDMap[pEntity][pID] : false;
	}

	// For now this is one-directional; we may need two for bi-directional sync but there are other ways to resolve this.
	mapExternalGUIDtoHeadlightGUID(pEntity, pExternalGUID, pHeadlightGUID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		this._ExternalGUIDMap[pEntity][pExternalGUID] = pHeadlightGUID;

		return true;
	}

	getHeadlightGUIDFromExternalGUID(pEntity, pExternalGUID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		return (this._ExternalGUIDMap[pEntity].hasOwnProperty(pExternalGUID)) ? this._ExternalGUIDMap[pEntity][pExternalGUID] : false;
	}

	getHeadlightIDFromExternalGUID(pEntity, pExternalGUID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		let tmpHeadlightGUID = this.getHeadlightGUIDFromExternalGUID(pEntity, pExternalGUID);
		return (tmpHeadlightGUID) ? this.getIDFromGUID(pEntity, tmpHeadlightGUID) : false;
	}
}

module.exports = HeadlightGUIDMap;

module.exports.default_configuration = defaultHeadlightGUIDMapOptions;
